export const initialState = {
  nameContainsSearchTerm: '',
  nameContainsSelectedValue: null,
  selectedRodData: [],
  searchSuggestions: [],
  gridData: [],
  totalBillsets:0,
  isNameContainDataFound:false,
  billSetsCreateType: { 
    create: false, 
    update: false 
  },
  loading: false,
  searchLoading: false,
  deleteButtonLoader: false,
  addBillsetLoading: false,
  isBillSetDeleted: false,
  isBillSetsCreated: false,  
  updateLoadding: false,
  dataUpdatingLoading: false,
  addBillSetsError: '',  
  isBillSetsUpdated: false,
  errors: {}, // You can store the form errors here 
  searchData: [],// You can store the service level data here
  selectededTab: 0,
  countries: [],
  currencies: [],
  serviceType: [],
  checkboxChecked:{
    allChecked: false,    
    allSelected: [],
    ditermineChecked: false,
  },
  billSetsInfo: {
    name: '', 
    description: '',
    last_Modified_User_Id: 0,
    last_Modified_Timestamp: new Date(),  
  },
  billSetsInfoError: {
    name: null, 
    description: null
  },
  billSets: [{    
    countryId: 0,
    currencyId: 0,
    isNew: true,
    isDeleted: false,
    rules: [{
      serviceTypeId: 0,
      billCalcTypeID: 0,
      startTime: new Date().setHours(8, 0),
      endTime: new Date().setHours(17, 0),
      baseMinuteQty: '',
      baseFee: '',
      incrementMinuteQty: '',
      incrementFee: '',
      isNew: true,
      isDeleted: false,
      billRuleID: 0,
    },{
      serviceTypeId: 0,
      billCalcTypeID: 0,
      startTime: new Date().setHours(8, 0),
      endTime: new Date().setHours(17, 0),
      baseMinuteQty: '',
      baseFee: '',
      incrementMinuteQty: '',
      incrementFee: '',
      isNew: true,
      isDeleted: false,
      billRuleID: 0,
    },{
      serviceTypeId: 0,
      billCalcTypeID: 0,
      startTime: new Date().setHours(8, 0),
      endTime: new Date().setHours(17, 0),
      baseMinuteQty: '',
      baseFee: '',
      incrementMinuteQty: '',
      incrementFee: '',
      isNew: true,
      isDeleted: false,
      billRuleID: 0,
    }],
    
  }],
  billSetsErrors: [{
    countryId: null,
    currencyId: null,
    isNew: true,
    isDeleted: false,
    rules: [{
      serviceTypeId: null,
      billCalcTypeID: null,
      startTime: null,
      endTime: null,
      baseMinuteQty: null,
      baseFee: null,
      incrementMinuteQty: null,
      incrementFee: null,
      isNew: true,
      isDeleted: false,
      billRuleID: 0,
    },{
      serviceTypeId: null,
      billCalcTypeID: null,
      startTime: null,
      endTime: null,
      baseMinuteQty: null,
      baseFee: null,
      incrementMinuteQty: null,
      incrementFee: null,
      isNew: true,
      isDeleted: false,
      billRuleID: 0,
    },{
      serviceTypeId: null,
      billCalcTypeID: null,
      startTime: null,
      endTime: null,
      baseMinuteQty: null,
      baseFee: null,
      incrementMinuteQty: null,
      incrementFee: null,
      isNew: true,
      isDeleted: false,
      billRuleID: 0,
    }]
  }],
  atLeastOneBillSetAdded: true,
  updateBillSetsMessage: '',
  pagination: {
    rowsPerPage: 25,
    page: 0,
  },
  backClick:false,
};
